/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from "axios";
import {
  appEntity,
  requestEnd,
  requestStart,
  toast,
} from "../entities/app.entity";
import { authEntity } from "../entities/auth.entity";
import { handleFetchError } from "./api";

export { fetchFromApi, handleFetchError } from "./api";
export { useApi } from "./useApi";

export const uploadSingleImage = async (
  file: File,
  url: string,
  key: string
) => {
  const token: string = authEntity.get()?.token ?? "";
  const baseApi: string = appEntity.get()?.baseApi ?? "";
  const formData = new FormData();
  formData.append(key, file);

  try {
    requestStart("img-upload");
    const { data } = await axios.post(`${baseApi}/uploads/${url}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    });
    if (data.message) toast(data.message);
    if (data.data) return data.data;
  } catch (error) {
    handleFetchError(error);
  } finally {
    requestEnd();
  }
};

export const uploadMultipleImages = async (
  files: File[],
  url: string,
  key: string,
  header?: any
) => {
  const token: string = authEntity.get()?.token ?? "";
  const baseApi: string = appEntity.get()?.baseApi ?? "";
  const formData = new FormData();
  files.forEach((file) => formData.append(key, file));

  try {
    requestStart("upload-image");
    const { data } = await axios.post(`${baseApi}/uploads/${url}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
        ...header,
      },
    });
    if (data.message) toast(data.message);
  } catch (error) {
    handleFetchError(error);
  } finally {
    requestEnd();
  }
};
